var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"backgroundContainer"},[_c('el-header',{staticClass:"navbar",staticStyle:{"height":"auto"}},[(_vm.isLoggedIn)?_c('UserInfo'):_vm._e()],1),_c('el-container',[_c('BhpAside'),_c('el-main',{staticClass:"marginMain"},[_c('router-view'),_c('SupportFooter')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }